<template lang="html">
  <v-dialog max-width="1200" :value="details_dialog.show" @input="close()">
    <v-card class="pa-2">
      <v-row>
        <v-col cols="6">
          <h3>Actions</h3>
          <v-card color="secondary lighten-1" class="pa-1 ma-2" v-for="(action_group, index) in details_dialog.actions" :key="index + '_ag'">
            <vue-json-pretty :data="action_group"></vue-json-pretty>
          </v-card>
        </v-col>
        <v-col cols="6">
          <h3>Mutations</h3>
          <v-card color="secondary lighten-1" class="pa-1 ma-2" v-for="(mutation_group, index) in details_dialog.mutations" :key="index + '_ag'">
            <vue-json-pretty :data="mutation_group"></vue-json-pretty>
          </v-card>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="close()" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'BugDetailsDialog',
  props: ['details_dialog'],
  components: {
    VueJsonPretty
  },
  created() {
    // this.dialog = this.details_dialog.show;
  },
  computed: {

  },
  methods: {
    close() {
      this.$emit('bugDetailsDialogClose', false);
    },
  }
}
</script>

<style lang="css" scoped>
.picker-card {
  width: 58px;
  height: 38px;
  float: left;
  margin: 5px;
  cursor: pointer;
}
.editor-workpackage-body {
  height: 200px;
}
.draggable-grid {
  min-width: 58px;
  min-height: 38px;
  display: grid;
}
</style>
